import { GridWithMargins } from '@rsa-digital/evo-shared-components/components/CardGrid/CardGrid/styles';
import {
  CardRichText,
  ContactCardContainer,
  JobTitle,
  LinkedInLink,
  ProfileImage,
  StyledLink,
} from '@rsa-digital/evo-shared-components/components/ContactCard/ContactCard/styles';
import ContactCardGrid from '@rsa-digital/evo-shared-components/components/ContactCard/ContactCardGrid';
import {
  Heading,
  Subheading,
} from '@rsa-digital/evo-shared-components/components/ContactCard/ContactCardGrid/styles';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const StyledContactCardGrid = styled(ContactCardGrid)`
  padding-top: ${spacing(3)};
  padding-bottom: ${spacing(3)};

  ${mediaQuery.tabletLandscape`
    padding-top: ${spacing(4)};
    padding-bottom: ${spacing(4)};
  `}

  ${Heading} {
    margin-top: 0;
    margin-bottom: 0;
  }

  ${Subheading} {
    margin-top: ${spacing(2)};
    margin-bottom: 0;
  }

  ${GridWithMargins} {
    margin-top: ${spacing(3)};
    margin-bottom: 0;
    row-gap: ${spacing(2)};
  }

  ${ContactCardContainer} {
    margin-top: 0;
    margin-bottom: 0;
  }

  ${JobTitle},
  ${StyledLink}, 
  ${CardRichText},
  ${LinkedInLink} {
    line-height: ${spacing(3)};
    font-size: 1rem; // 16px;
  }

  ${ProfileImage} {
    object-fit: cover;
  }
`;
